import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import YoutubeEmbed from '../elements/YoutubeEmbed';

const HelpContent = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    'testimonial section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'testimonial-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames('tiles-wrap', pushLeft && 'push-left');

  const sectionHeader = {
    title: 'Keep Me Out — Help Center',
    paragraph: ''
  };

  const IssueRestartIDs = {
    Realme: 'a7JIHTYZmq4',
    XIAOMI: 'test'
  };

  const IssueUninstallIDs = {
    Samsung: 'V41SmJuoedc',
    XIAOMI: 'test'
  };

  return (
    <section {...props} className={outerClasses}>
      <div className='container'>
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className='center-content' tag='h1' />
          <h4 className='mt-0 mb-16'>Fix A Problem</h4>
          <Accordion style={{ marginBottom: 60 }}>
            <AccordionItem uuid='a'>
              <AccordionItemHeading>
                <AccordionItemButton id='IssueRestart'>
                  Lock Breaking After Restart
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {/* WIP */}
                <h5 className='mt-0 mb-16'>Video Guide</h5>
                {/* <ButtonGroup style={{ marginBottom: 10 }}>
                  <Button tag='a' color='primary' href='#'>
                    Samsung
                  </Button>
                  <Button tag='a' color='dark' href='#'>
                    XIAOMI
                  </Button>
                </ButtonGroup> */}
                <YoutubeEmbed embedId={IssueRestartIDs.Realme} />
                <p>
                  We recommend following our device specific video guide above.
                </p>
                <ol style={{ color: 'white' }}>
                  <li>
                    Enter the app information by long pressing the Keep Me Out
                    app icon and tapping on the “App info” button.
                  </li>
                  <li>
                    Select “Battery Usage” from the following info screen.
                  </li>
                  <li>
                    Enable “Allow auto-launch” from the privacy permissions.
                  </li>
                  <li>
                    Remember you need to also enable the option “Keep Locked
                    After Device Reboot / Restart” from the in-app settings
                    screen.
                  </li>
                </ol>
              </AccordionItemPanel>
            </AccordionItem>
            {/* WIP */}
            <AccordionItem uuid='b' id='IssueUninstall'>
              <AccordionItemHeading>
                <AccordionItemButton>
                  How to Uninstall the App
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {/* WIP */}
                <h5 className='mt-0 mb-16'>Video Guide</h5>
                {/* <ButtonGroup style={{ marginBottom: 10 }}>
                  <Button tag='a' color='primary' href='#'>
                    Samsung
                  </Button>
                  <Button tag='a' color='dark' href='#'>
                    XIAOMI
                  </Button>
                </ButtonGroup> */}
                <YoutubeEmbed embedId={IssueUninstallIDs.Samsung} />
                <p>
                  We recommend following our device specific video guide above.
                </p>
                <ol style={{ color: 'white' }}>
                  <li>
                    Open the Keep Me Out Settings screen from the icon in the
                    top right.
                  </li>
                  <li>Disable the option “Device Administrator”.</li>
                  <li>Uninstall the app from your phone's home screen.</li>
                </ol>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <h4 className='mt-0 mb-16' style={{ marginBottom: 20 }}>
            FAQ
          </h4>
          <h5 className='mt-0 mb-16'>
            I have encountered a bug / problem with your app, where can I report
            it?
          </h5>
          <p className='text-sm mb-32'>
            Please write a short description of your problem to{' '}
            <a href='mailto:keepmeout.help@eudaitec.com'>
              keepmeout.help@eudaitec.com
            </a>
            . Please be aware that due to the amount of mail we get, a reply may
            take some time.
          </p>
          <h5 className='mt-0 mb-16'>
            Does Keep Me Out store or read my personal data?
          </h5>
          <p className='text-sm mb-32'>
            At eudaiTec we value your privacy and don’t believe in storing or
            selling personal or sensitive user data, as a principle.
          </p>
          <h5 className='mt-0 mb-16'>
            Can I still receive calls when my phone is in “lock mode”?
          </h5>
          <p className='text-sm mb-32'>
            Yes, since the issue of an emergency could arise outside of your
            influence, we feel this is important. If you want to block contacts
            from calling you, we advise you to use your phone's privacy settings
            instead.
          </p>
          <h5 className='mt-0 mb-16'>
            Can I call people while my phone is in lock mode?
          </h5>
          <p className='text-sm mb-32'>
            You can enable “emergency calling” in the app settings. That way you
            can add contacts to your emergency contact list, so you can easily
            reach them during lock times.
          </p>
          <h5 className='mt-0 mb-16'>How can I add emergency contacts?</h5>
          <p className='text-sm mb-32'>
            Open Settings on your device. Search for “Emergency Contacts”. Add
            contacts from your contact list.
          </p>
          <h5 className='mt-0 mb-16'>
            Can I disable the lock for specific apps?
          </h5>
          <p className='text-sm mb-32'>
            Yes. With Allowed Apps you can choose apps that stay usable during a
            lock: 1 app on the free plan, up to 15 with Premium. Keep Me Out
            needs Usage access and notifications for this.
          </p>
          <h5 className='mt-0 mb-16'>
            I have a feature idea / suggestion for your app, where can I share
            it?
          </h5>
          <p className='text-sm mb-32'>
            We welcome you to contact us at{' '}
            <a href='mailto:keepmeout.help@eudaitec.com'>
              keepmeout.help@eudaitec.com
            </a>
            . Please be aware that due to the amount of mail we get, a reply is
            not guaranteed and may take some time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HelpContent;
